"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const left_panel_1 = require("./left-panel/left-panel");
const setting_item_1 = require("./left-panel/setting-item");
const profile_layout_1 = require("./layout/profile/profile-layout");
const react_router_dom_1 = require("react-router-dom");
const security_layout_1 = require("./layout/security/security-layout");
const log_view_layout_1 = require("../../component/log-view-layout");
const log_1 = require("../../model/log");
exports.SettingsPage = (0, react_1.memo)(() => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [profileType, setProfileType] = (0, react_1.useState)(setting_item_1.SettingConfigurationType.Profile);
    const handleProfileTypeChange = (0, react_1.useCallback)((type) => {
        setProfileType(type);
    }, []);
    (0, react_1.useEffect)(() => {
        if (profileType === setting_item_1.SettingConfigurationType.Privacy) {
            navigate("/privacy");
        }
    }, [navigate, profileType]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", flex: 1, children: [(0, jsx_runtime_1.jsx)(log_view_layout_1.LogViewLayout, { eventName: log_1.LogEventViewName.SettingsPage }), (0, jsx_runtime_1.jsx)(left_panel_1.LeftPanel, { profileType: profileType, onProfileTypeChange: handleProfileTypeChange }), profileType === setting_item_1.SettingConfigurationType.Profile && (0, jsx_runtime_1.jsx)(profile_layout_1.ProfileLayout, {}), profileType === setting_item_1.SettingConfigurationType.Security && (0, jsx_runtime_1.jsx)(security_layout_1.SecurityLayout, {})] }));
});
exports.SettingsPage.displayName = "ProfilePage";
exports.default = exports.SettingsPage;
